export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/crm/crm.jpg'),
        title: 'ProphetCRM',
        description: 'Helping Chinese customers go to overseas',
        component: ''
      }
  ],
  step1:{
    title: `Help small and medium enterprises carry out digital transformation, using data to mining customers effectively and service client.`,
    description: `ProphetCRM helps Chinese customers go to overseas, in addition, it also helps overseas customers  access into the Chinese market`,
    cases: [
      { title: 'Lots of overseas project experience', imgUrl: require('../../../assets/images/services/crm/case1.png') },
      { title: 'Overseas customer resources', imgUrl: require('../../../assets/images/services/crm/case2.png') },
      { title: 'Overseas customer resources', imgUrl: require('../../../assets/images/services/crm/case3.png') }
    ]
  },
  step2: {
    title: 'How can ProphetCRM help you?',
    description: '',
    cases: [
      {
        imgUrl: require('../../../assets/images/services/crm/1.png'),
        title: 'Transparent Communication',
        description: `ProphetCRM is embedded in Outlook — automatically tracking and recording your team’s activities.`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/2.png'),
        title: 'High-Touch Environment',
        description: `ProphetCRM’s tailored Sales Automations ensure that your customers receive rapid, meaningful responses. `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/3.png'),
        title: 'Effortless Adoption',
        description: `Familiar Excel-like dashboards help your team adopt ProphetCRM seamlessly into their daily process.  `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/4.png'),
        title: 'Powerful Analytics',
        description: `Forecasts and Activity Tracking roll up into insightful reports, allowing Managers to confidently make key decisions.  `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/5.png'),
        title: 'Personalized Documents',
        description: `Quotes, Documents, and Forms produced directly from a ProphetCRM Record enable your team to operate from one system.  `
      },
      {
        imgUrl: require('../../../assets/images/services/crm/6.png'),
        title: 'Be MOBILE',
        description: `ProphetCRM’s Mobile App for IOS and Android keeps your teams productive, even when they’re on the move.  `
      }
    ]
  },
  step3: {
    title: 'A CRM Designed For Teams',
    imgUrl: require('../../../assets/images/services/crm/placeholder1.jpg'),
    description: `ProphetCRM: Built for Teams! ProphetCRM enables sales and project teams to operate cohesively. Users can collaborate with members of their core team, or across departments to track progress on deliverables, and ensure deadlines are met.<br/>
Think of ProphetCRMas a power-booster for Outlook. ProphetCRM allows your team to continue doing their daily "Blocking & Tackling" within the environment they already live and breathe in, Outlook.`
  },
  step4: {
    title: 'What do we value?',
    secondTitle: 'Our Customers are always our top priority.',
    description: `We look to grow long-term relationships with our partners. Every part of your ProphetCRM Experience is handled in-house, without exceptions. This enables a seamless experience from the moment your implementation begins. We are a CRM in the business of providing our customers longstanding value.`,
    cases: [
      {
        imgUrl: require('../../../assets/images/services/crm/a.png'),
        title: 'Implementations',
        description: `Our team of Project Managers works to learn your business model to ensure that ProphetCRM accurately reflects your business processes.`
      },
      {
       imgUrl: require('../../../assets/images/services/crm/b.png'),
        title: 'Support',
        description: `We are incredibly proud of our top-rated Support Staff, beating Salesforce by 10.9% (G2 Crowd, 2018).`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/c.png'),
        title: 'Customer Success',
        description: `After deployment a Customer Success Manager is assigned to your account to ensure that you receive continual value.`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/d.png'),
        title: 'Integrations',
        description: `Our Open API allows ProphetCRM to integrate with nearly all ERP platforms, allowing for cohesion between your essential systems.`
      }
    ]
  },
  step5: {
    title: 'Technical Details & Compatibility',
    imgUrl: require('../../../assets/images/services/crm/placeholder2.jpg'),
    description: `We offer Cloud and On-Premise solutions to fit your needs. Additionally, ProphetCRM is totally compatible with Microsoft Office 365. Our Mobile App is user-friendly, and available on all major platforms. We comply with SOC-2 and GDPR regulations.<br/>
Do you have client information from a dated CRM or in Excel spreadsheets? Our Migrations Team works with you to ensure that essential historical data is reflected in your new system.`
  }
}
